import { AdminClassroomLayout } from "@/pages/admin/AdminClassroomLayout";
import { StudentScorePage } from "@/pages/teacher/StudentScorePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/classrooms/$classroomId/students/$studentId/score/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { classroomId, studentId } = Route.useParams();
  return (
    <AdminClassroomLayout>
      <StudentScorePage classroomId={classroomId} studentId={studentId} scope="admin" />
    </AdminClassroomLayout>
  );
}
